import { CountryFlagGlyph } from '@sunwebgroup/uds-ui/icon-country-flag'

export function resolveLanguageCode(localeCode: string) {
  switch (localeCode.toLowerCase()) {
    case 'nl-nl':
      return 'NL'
    case 'nl-be':
      return 'NL'
    case 'fr-be':
      return 'FR'
    case 'da-dk':
      return 'DA'
    case 'fr-fr':
      return 'FR'
    case 'sv-se':
      return 'SV'
    case 'en-gb':
      return 'EN'
    case 'de-de':
      return 'DE'
  }
}

export function getFlagCodeByCountry(countryCode: string): CountryFlagGlyph {
  switch (countryCode.toUpperCase()) {
    case 'NL':
      return 'IconFlagNl'
    case 'DK':
      return 'IconFlagDk'
    case 'FR':
      return 'IconFlagFr'
    case 'DE':
      return 'IconFlagDe'
    case 'SE':
      return 'IconFlagSe'
    case 'UK':
      return 'IconFlagGb'
    case 'BE':
      return 'IconFlagBe'
    default:
      return 'IconFlagNl'
  }
}

export function getPartyCompositionType(partyCompositionId: string) {
  const typesIds: Record<string, string> = {
    11: 'type_alone',
    12: 'type_withpartner',
    13: 'type_friends',
    14: 'type_family',
    15: 'type_singleparent',
    16: 'type_group',
  }
  const typeId = partyCompositionId in typesIds ? typesIds[partyCompositionId] : 'type_unknown'

  return typeId
}

export function formatRating(rating: string) {
  const ratingNumber = Number.parseFloat(rating.replace(',', '.'))

  if (Number.isNaN(ratingNumber)) {
    return 'N/A'
  }

  return (ratingNumber < 10 || !Number.isInteger(ratingNumber))
    ? ratingNumber.toFixed(1)
    : String(ratingNumber)
}
